import type { NavItem } from '@/app/nav/collect'

/** The shell already declares the Bank group with Accounts and Transactions (`src/modules/shell/nav.ts`, `ac-bank`). */
const nav: NavItem[] = []

export default nav
